module.exports = __webpack_public_path__ + "img/steps4.da3f1dbd.svg";